import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { ERROR_MSG } from "../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../constants/contexConstant";
import { GET_HYPERSROT_MEMBERS_API } from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import request from "../../services/request";
import Button from "../../shared/ui/Button";
import DateTimePickerBlockFormik from "../../shared/ui/Form/DateTimePickerBlockFormik";
import FormikLabeledInput from "../../shared/ui/Form/FormikLabeledInput";
import LabeledFormikSelect from "../../shared/ui/Form/LabeledFormikSelect";
import { reassignFormValidationSchema } from "../../shared/ui/Form/schema";

const maxDate = new Date();
maxDate.setDate(maxDate.getDate() + 13);

const ReAssignForm = ({ details, surveyD, plantId }) => {
    const [assignee, setAssignee] = useState([]);
    const { dispatch } = useContextState();
    const fetchAssignee = async () => {
        try {
            dispatch({ type: SET_LOADER });
            let res = await request.authGet({
                endpoint: GET_HYPERSROT_MEMBERS_API,
            });
            let response = res?.data;
            const transformedArray = response.members.map((member) => ({
                value: member.name,
                label: member.name,
                id: member.id,
            }));
            setAssignee(transformedArray);
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            dispatch({
                type: SET_ERROR,
                payload: typeof error === "string" ? error : ERROR_MSG,
            });
        }
    };
    useEffect(() => {
        if (assignee?.length == 0) {
            fetchAssignee();
        }
    }, [surveyD]);
    let surveyDate = surveyD ? new Date(surveyD * 1000) : new Date();
    const contactPhoneNo = details?.contactPersonNumber
        ? details?.contactPersonNumber?.startsWith("91")
            ? details.contactPersonNumber.slice(2)
            : details?.contactPersonNumber || ""
        : details?.contactPersonPhone?.startsWith("91")
        ? details.contactPersonPhone.slice(2)
        : details?.contactPersonPhone || "";

    const handleSubmit = async (values) => {
        try {
            dispatch({ type: SET_LOADER });

            const assigneeObj = assignee.find(
                (a) => a.value === values.assignee
            );
            const surveyorObj = assignee.find(
                (a) => a.value === values.surveyor
            );

            const selectedDate = new Date(values.date);
            selectedDate.setHours(values.hour);
            selectedDate.setMinutes(values.minutes);
            const timestamp = Math.floor(selectedDate.getTime() / 1000);

            const body = {
                plantId: plantId,
                assigneeId: assigneeObj ? assigneeObj.id : null,
                surveyorId: surveyorObj ? surveyorObj.id : null,
                date: timestamp,
                contactPersonName: values.contactPerson,
                contackPersonPhone: values.contactPhoneNo,
            };

            await request.authPatch({
                endpoint: "/admin/survey/update",
                body,
            });

            dispatch({ type: RESET_LOADER });
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            dispatch({
                type: SET_ERROR,
                payload: typeof error === "string" ? error : ERROR_MSG,
            });
        }
    };

    return (
        <div className="bg-white flex   rounded-lg px-2 md:py-2 flex-col lg:flex-row lg:flex-wrap gap-3.2">
            <Formik
                enableReinitialize={true}
                initialValues={{
                    assignee: details?.assigneeName || assignee[0]?.value || "",
                    surveyor: details?.surveyorName || assignee[0]?.value || "",
                    contactPerson: details?.contactPersonName || "",
                    contactPhoneNo: contactPhoneNo,
                    date: surveyDate,
                    hour: surveyDate.getHours() || 10,
                    minutes: surveyDate.getMinutes() || 0,
                }}
                validationSchema={reassignFormValidationSchema}
                onSubmit={handleSubmit}
            >
                {() => (
                    <Form className="flex flex-col gap-1.2 w-full">
                        <div className=" lg:grid lg:grid-cols-2 lg:gap-2 w-full">
                            <LabeledFormikSelect
                                label="Project Assignee"
                                name="assignee"
                                options={assignee}
                                required
                            />
                            <LabeledFormikSelect
                                label="Surveyor Name"
                                name="surveyor"
                                options={assignee}
                                required
                            />
                        </div>
                        <div className="flex flex-col gap-1  lg:grid lg:grid-cols-2 lg:gap-2 w-full">
                            <FormikLabeledInput
                                label="Contact Person Name"
                                name="contactPerson"
                                placeholder="Contact Person Name"
                                type="text"
                                required
                            />
                            <FormikLabeledInput
                                label="Contact Person Number"
                                name="contactPhoneNo"
                                placeholder="Contact Person Number"
                                type="text"
                                required
                            />
                        </div>
                        <DateTimePickerBlockFormik
                            label="Survey Date"
                            dateName="date"
                            hourName="hour"
                            minuteName="minutes"
                            maxDate={maxDate}
                            minDate={surveyDate}
                        />
                        <Button
                            type="submit"
                            className="!rounded-[3rem] text-base "
                        >
                            Update Details
                        </Button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ReAssignForm;
